const portfolioState = {
  list: [],
  selected: null,
  isLoading: false,
}

export default portfolioState
